const DEFAULT_API_BASE_URL = "https://api.varsanpr.com";

function trustedApiBaseUrl() {
  return (process.env.VUE_APP_API_BASE_URL || DEFAULT_API_BASE_URL).replace(/\/$/, "");
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function createClaimsApiUrlRewriter() {
  const override = (process.env.VUE_APP_CLAIMS_API_URL || "").trim();
  if (process.env.NODE_ENV !== "development" || !override) {
    return (url) => url;
  }

  // Keep cookie-authenticated requests on the configured API host.
  const trustedOrigin = new URL(trustedApiBaseUrl()).origin;
  let target;
  try {
    target = new URL(override);
  } catch {
    throw new Error("VUE_APP_CLAIMS_API_URL must be a valid gateway API URL.");
  }
  if (
    target.origin !== trustedOrigin ||
    target.username ||
    target.password ||
    target.search ||
    target.hash ||
    !/^\/api\/[a-zA-Z0-9_-]+\/?$/.test(target.pathname)
  ) {
    throw new Error(
      `VUE_APP_CLAIMS_API_URL must use ${trustedOrigin}/api/<api-name>.`
    );
  }

  const claimsUrl = new RegExp(
    `^${escapeRegExp(trustedApiBaseUrl())}/api/claims(?=/|[?#]|$)`
  );
  const baseUrl = `${target.origin}${target.pathname.replace(/\/$/, "")}`;
  return (url) =>
    typeof url === "string" ? url.replace(claimsUrl, () => baseUrl) : url;
}
